import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import './i18n';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { PageLoader } from './components/LoadingSpinner';
import ScrollToTop from './components/ScrollToTop'; // Komponen agar selalu scroll ke atas
import CookieConsent from './components/CookieConsent';

import Home from './pages/Home';
import Rooms from './pages/Rooms';
import RoomDetail from './pages/RoomDetail';
import Gallery from './pages/Gallery';
import { Promotions, Restaurant, MeetingEvents, Attractions, FacilitiesPage } from './pages/OtherPages';
import FacilityDetail from './pages/FacilityDetail';
import AttractionDetail from './pages/AttractionDetail';
import { FAQPage, PrivacyPage, TermsPage, AboutPage, ContactPage, ReviewsPage } from './pages/StaticPages';
import InvoicePage from './pages/InvoicePage';
import VerifyBookingPage from './pages/VerifyBookingPage';

// Wrapper untuk layout Navbar & Footer
function W({ children }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <Router>
      {/* ScrollToTop diletakkan di sini agar memantau setiap perpindahan halaman */}
      <ScrollToTop /> 
      
      <Suspense fallback={<PageLoader />}>
        <Toaster 
          position="top-right" 
          toastOptions={{ 
            duration: 4000, 
            style: { fontFamily: '"DM Sans", sans-serif', fontSize: '14px' } 
          }} 
        />
        <Routes>
          {/* Public Routes Only */}
          <Route path="/" element={<W><Home /></W>} />
          <Route path="/rooms" element={<W><Rooms /></W>} />
          <Route path="/rooms/:slug" element={<W><RoomDetail /></W>} />
          <Route path="/gallery" element={<W><Gallery /></W>} />
          <Route path="/restaurant" element={<W><Restaurant /></W>} />
          <Route path="/meeting" element={<W><MeetingEvents /></W>} />
          <Route path="/facilities" element={<W><FacilitiesPage /></W>} />
          <Route path="/facilities/:slug" element={<W><FacilityDetail /></W>} />
          <Route path="/promotions" element={<W><Promotions /></W>} />
          <Route path="/attractions" element={<W><Attractions /></W>} />
          <Route path="/attractions/:slug" element={<W><AttractionDetail /></W>} />
          <Route path="/about" element={<W><AboutPage /></W>} />
          <Route path="/contact" element={<W><ContactPage /></W>} />
          <Route path="/reviews" element={<W><ReviewsPage /></W>} />
          <Route path="/invoice" element={<W><InvoicePage /></W>} />
          <Route path="/invoice/:code" element={<W><InvoicePage /></W>} />
          <Route path="/verify/:code" element={<W><VerifyBookingPage /></W>} />
          <Route path="/verify" element={<W><VerifyBookingPage /></W>} />
          <Route path="/faq" element={<W><FAQPage /></W>} />
          <Route path="/privacy" element={<W><PrivacyPage /></W>} />
          <Route path="/terms" element={<W><TermsPage /></W>} />
          <Route path="*" element={<W><NotFound /></W>} />
        </Routes>
      </Suspense>
      <CookieConsent />
    </Router>
  );
}

// Halaman 404 yang disempurnakan dengan Multibahasa (ID, EN, ZH)
function NotFound() {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  const title = lang === 'zh' ? '页面未找到' : lang === 'en' ? 'Page Not Found' : 'Halaman tidak ditemukan';
  const desc = lang === 'zh' ? '抱歉，您要查找的页面不存在。' : lang === 'en' ? 'Sorry, the page you are looking for does not exist.' : 'Maaf, halaman yang Anda cari tidak ada.';
  const btnText = lang === 'zh' ? '返回首页' : lang === 'en' ? 'Back to Home' : 'Kembali ke Beranda';

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-6 pt-20 pb-20">
      <div className="text-center space-y-4">
        <div className="font-display text-8xl text-primary-200 font-bold drop-shadow-sm">404</div>
        <h2 className="font-display text-2xl text-dark font-bold">{title}</h2>
        <p className="text-gray-500 font-sans">{desc}</p>
        <Link 
          to="/" 
          className="inline-block px-8 py-3 bg-primary-700 text-white rounded-xl font-sans font-semibold hover:bg-primary-600 transition-all hover:-translate-y-1 shadow-md mt-4"
        >
          {btnText}
        </Link>
      </div>
    </div>
  );
}